export default "__VITE_ASSET__CWOqu5Eg__"